$(function() {
    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.expand = '300';
    window.lazySizesConfig.loadMode = 1;

    $(document).ready(function() {
        $('[data-toggle="html-tooltip"]').tooltip({
            placement: 'top',
            html: 'true'
        });
    });

    $('body').addClass('loaded');

    /* Listing page */
    $('[data-listing-tile]:not(a)').on('click', function() {
        window.location = $(this).find('a.product-link').attr('href');
    });

    /* YouTube Video
     ================================================== */
    $('.embed-responsive iframe').addClass('embed-responsive-item');

    /* UE COOKIE
     =================================================== */

    if (document.cookie.indexOf('eucookie') === -1) {
        $('#eucookielaw').show();
        SetCookie('eucookie', 'eucookie', 365 * 10);
    } else {
        $('#eucookielaw').remove();
    }

    $('#close').click(function() {
        $('#eucookielaw').css('display', 'none');
    });

    function SetCookie(c_name, value, expiredays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + expiredays);
        document.cookie = c_name + '=' + escape(value) + ';path=/' + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString());
    }

    /* CYCLE CAROUSEL
     ================================================== */

    function cycle_visible_width() {
        // Getting the width and checking my layout
        var docwidth = $(document).width();
        if (docwidth < 479) {
            $('#category-slideshow').data('cycle-carousel-visible', 1);
        } else if (docwidth > 479 && docwidth < 768) {
            $('#category-slideshow').data('cycle-carousel-visible', 2);
        } else {
            $('#category-slideshow').data('cycle-carousel-visible', 3);
        }

        $('#category-slideshow').cycle('reinit');
    }

    $('document').ready(function() {
        setTileTariffHeights();
    });

    $(window).resize(function() {
        setTileTariffHeights();
    });

    $filters = $($('#filter-button').attr('data-filter-id'));

    /* Make the checkbox clickable if you click any part of the filter section ( <li> ) - start */
    $filters.find('li.check').click(function(event) {
        if (event.target.type !== 'checkbox') {
            $(':checkbox', this).trigger('click');
        }
    });

    /* Make the checkbox clickable if you click any part of the filter section ( <li> ) - end */

    /* Make the checkbox clickable if you click any part of the filter section ( <li> ) - start */
    $filters.find('li.check').click(function(event) {
        if (event.target.type !== 'radio') {
            $(':radio', this).trigger('click');
        }
    });

    /* Make the checkbox clickable if you click any part of the filter section ( <li> ) - end */

    /* Make the radio button clickable if you click any part of the filter section ( <li> ) - start */
    $filters.find('li.radiobtn').click(function(event) {
        if (event.target.type !== 'radio') {
            $(':radio', this).trigger('click');
        }
    });

    /* Make the radio button clickable if you click any part of the filter section ( <li> ) - end */

    $('#upfront-slider').hide();
    if ($('#upfront_check').is(':checked')) {
        $('#upfront-slider').show(300);
    } else {
        $('#upfront-slider').hide(300);
    }
    $('#upfront_check').click(function() {
        if ($(this).is(':checked')) {
            $('#upfront-slider').show(300);
        } else {
            $('#upfront-slider').hide(300);
        }
    });

    /* Product Page Filters end */
    /* Make the checkbox clickable if you click any part of the filter section - start */
    /*   $('#prod-filter-slide li.check').click(function(event) {
     if (event.target.type !== 'checkbox') {
     $(':checkbox', this).trigger('click');
     }
     });

     /* Make the radio clickable if you click any part of the filter section - start */
    $('#prod-filter-slide li.check').click(function(event) {
        if (event.target.type !== 'radio') {
            $(':radio', this).trigger('click');
        }
    });

    /* Make the checkbox clickable if you click any part of the filter section - end */
    /* Make the radio button clickable if you click any part of the filter section - start */
    $('#prod-filter-slide li.radiobtn').click(function(event) {
        if (event.target.type !== 'radio') {
            $(':radio', this).trigger('click');
        }
    });

    /* Make the radio button clickable if you click any part of the filter section - end */
    $('[id^=clearproductsgo]').click(function() {
        location.reload();
    });

    /* MASONARY & SPECS
     ================================================== */

    function masonry_show() {
        var msnry = new Masonry('#mason-show');
        $('#mason-show').css('visibility', 'hidden');
        setTimeout(function() {
            msnry.layout();
            $('#mason-show').css('visibility', 'visible');
        }, 500);
    }

    $('li.product-specs a').click(function() {
        masonry_show();
    });

    $('.panel-title a[href="#specs-collapse"], .panel-title a[href="#specs"]').click(function() {
        masonry_show();
    });

    $('.collapse:has(.js-masonry)').on('show.bs.collapse shown.bs.collapse', function() {
        $(this).find('.js-masonry').each(function(i, elem) {
            $(elem).data('masonry').layout();
        });
    });

    $filters.find('li.check-all').click(function() {
        $(this).parents('ul').find('input[type=checkbox]').removeAttr('checked');
    });

    $('#product-tabs').tabCollapse();

    $('.product-details').on('click', 'a[data-scroll-to-reviews]', function(e) {
        e.preventDefault();
        jQuery('html, body').animate({
            scrollTop: jQuery('[data-product-full-reviews]').offset().top
        }, 800);
    });

    $('a.full-specs').click(function() {
        $('.product-specs').find('a').trigger('click');
        jQuery('html, body').animate({
            scrollTop: jQuery('#product-tabs').offset().top
        }, 800);
    });

    hideOnlyIfs();

    $filters.find('input[type=checkbox]').change(function() {
        $onlyIfs = $("li[data-onlyif='" + $(this).attr('id') + "']");

        if ($(this).is(':checked')) {
            $onlyIfs.slideDown(200);
        } else {
            $onlyIfs.slideUp(200);
        }
    });

    /* Search Box start */
    $('.search-toggle').click(function() {
        $('#search-box').toggle();
    });

    /* Search Box end */

    /* Color / Capacity Selector */
    $('select.product-colour-selector, select.product-capacity-selector').on('change', function() {
        var location = $(this).val();
        if (location) {
            window.location = location;
        }
    });

    $('.static-gift-group-chooser-cms').on('change', function() {
        var groupName = $(this).val();
        $('.static-gift-chooser-cms').each(function() {
            var $this = $(this);
            if ($this.attr('data-static-gift-group-name') == groupName) {
                $this.show();
                $this.attr('disabled', false);
            } else {
                $this.hide();
                $this.attr('disabled', true);
            }
        });
    }).change();

    $('.static-gift-chooser-cms').on('change', function() {
        var $this = $(this);
        if ($this.val() != '') {
            $('.static-gift-chooser-btn-cms').attr('disabled', false);
        } else {
            $('.static-gift-chooser-btn-cms').attr('disabled', true);
        }
    }).val('').change();

    $('.static-gift-chooser-btn-cms').on('click', function() {
        var giftSlug = null;
        $('.static-gift-chooser-cms').each(function() {
            var $this = $(this);
            if ($this.is('[disabled]') || !$this.val()) {
                return;
            }
            giftSlug = $this.val();
        });
        if (giftSlug) {
            var location = '/mobile-phones/contract/free-gifts/' + giftSlug;
            window.location = location;
        }
    });

    $('#deal-finder .phone-selector').on('change', 'select', function() {
        var $this = $(this);
        if ($this.val() != '') {
            $('input[data-input-name="search_query"]').val($this.val());
            go_to_step('.step-one', '.step-two');
        }
    });

    $('#deal-finder').on('change', 'select.input-change', function() {
        var $this = $(this);
        var $input_target = $(this).data('input-target');
        if ($this.val() != '') {
            $('input[data-input-name="' + $input_target + '"]').val($this.val());
        }
    });

    $('#deal-finder .step-two').on('change', 'select.input-change', function() {
        go_to_step('.step-two', '.step-three');
    });

    $('#deal-finder .step-three').on('change', 'select.input-change', function() {
        var $thisVal = $(this).val();
        if ($thisVal != '') {
            var $selectedLi = $('.ui-selectx3 li a:contains("' + $thisVal + '")');

            var input_targetx1 = $($selectedLi).closest('.ui-selectx3').data('input-targetx1');
            var input_targetx2 = $($selectedLi).closest('.ui-selectx3').data('input-targetx2');
            var input_targetx3 = $($selectedLi).closest('.ui-selectx3').data('input-targetx3');

            var input_valuex1 = $($selectedLi).data('input-valuex1');
            var input_valuex2 = $($selectedLi).data('input-valuex2');
            var input_valuex3 = $($selectedLi).data('input-valuex3');

            $(".input-target[data-input-name='" + input_targetx1 + "']").val(input_valuex1);
            $(".input-target[data-input-name='" + input_targetx2 + "']").val(input_valuex2);
            $(".input-target[data-input-name='" + input_targetx3 + "']").val(input_valuex3);

            $('.deal-finder-button').hide().fadeIn(800);
        } else {
            $('.deal-finder-button').hide();
        }
    });

    $('#e2save-carousel').swiperight(function() {
        $('#e2save-carousel').carousel('prev');
    });
    $('#e2save-carousel').swipeleft(function() {
        $('#e2save-carousel').carousel('next');
    });

    countdownClock.init('.tag-countdown');

    function onClickBuyNowOnRefurbishedProductInNonRefurbishedTariffTable(event) {
        var popup = $('#refurbishedConfirmationPopup');
        if (!popup.is(':visible')) {
            event.preventDefault();
            var popupBuyNowButton = popup.find('a.add-to-basket-btn');
            popupBuyNowButton.unbind('click');
            var originalBuyNowButton = this;
            popupBuyNowButton.on('click', function() {
                originalBuyNowButton.click();
            });
            $(popup).modal();
        }
    }

    $(document).on(
        'click',
        '.deal-container-for-new-product .listing-tile-for-refurbished-product a.add-to-basket-btn',
        onClickBuyNowOnRefurbishedProductInNonRefurbishedTariffTable
    );

});

function hideOnlyIfs() {
    $($filters).find('li[data-onlyif]').each(function() {
        if (!$('#' + $(this).data('onlyif')).is(':checked')) {
            $(this).hide();
        }
    });
}

function isScrolledIntoView(elem) {
    var t = $(elem),
        docViewTop = $(window).scrollTop(),
        docViewBottom = docViewTop + $(window).height(),
        elemTop = t.offset().top,
        elemBottom = elemTop + t.height();

    return ((elemBottom <= docViewBottom) && (elemTop <= docViewTop));
}

function isEmpty(object) {
    return (typeof (object.value) == 'string' && object.value != '');
}

function updateFilters(filtersData) {
    $('#filters-list').find("input[type='select'][id^='filter_']").each(function() {
        var parts = $(this).attr('id').substr(7).split('-');

        if (filtersData[parts[0]][parts[1]] && filtersData[parts[0]][parts[1]] > 0) {
            $(this).removeAttr('disabled');
        } else {
            $(this).attr('disabled', 'disabled');
        }
    });
    $('#filter-box-lg').find("input[type='select'][id^='filter_']").each(function() {
        var parts = $(this).attr('id').substr(7).split('-');

        if (filtersData[parts[0]][parts[1]] && filtersData[parts[0]][parts[1]] > 0) {
            $(this).removeAttr('disabled');
        } else {
            $(this).attr('disabled', 'disabled');
        }
    });
}

var mySwiper = new Swiper('.swiper-container', {
    slidesPerView: 'auto',
    calculateHeight: true,
    grabCursor: true
});
var mySwiper2 = new Swiper('.swiper-container2', {
    setWrapperSize: true,
    pagination: '.pagination2',
    paginationClickable: true,
    slidesPerView: '1',
    grabCursor: true
});
var mySwiper3 = new Swiper('.swiper-container3', {
    pagination: '.pagination3',
    paginationClickable: true,
    slidesPerView: '1',
    grabCursor: true,
    resizeReInit: true,
    calculateHeight: true
});
var mySwiper4 = new Swiper('.swiper-container4', {
    pagination: '.swiper-pagination',
    paginationClickable: '.swiper-pagination',
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    simulateTouch: false,
    setWrapperSize: true,
    spaceBetween: 0,
    loop: true,
    keyboardControl: true,
    calculateHeight: true
});

/* DROPDOWN MENUS
 ================================================== */

function DropDown(el) {
    this.dd = el;
    this.placeholder = this.dd.children('span');
    this.opts = this.dd.find('ul.dropdown > li');
    this.val = '';
    this.index = -1;
    this.initEvents();
}

DropDown.prototype = {
    initEvents: function() {
        var obj = this;

        obj.dd.on('click', function() {
            $(this).toggleClass('active');
            return false;
        });

        obj.opts.on('click', function() {
            var opt = $(this);
            obj.val = opt.text();
            obj.index = opt.index();
            obj.placeholder.text(obj.val);
        });
    },
    getValue: function() {
        return this.val;
    },
    getIndex: function() {
        return this.index;
    }
};
$(function() {

    $('.wrapper-dropdown').each(function() {
        var dd = new DropDown($(this));
    });

    $(document).click(function() {
        // all dropdowns
        $('.wrapper-dropdown').removeClass('active');
    });

    $('.dropdown.colour-dropdown a, .dropdown.link-dropdown a').click(function() {
        window.location = $(this).attr('href');
    });

});

/* UI SELECTIONS
 ================================================== */

/* UI Select Field */

$('.ui-select').on('click', 'a', function() {
    var t = $(this),
        input_target = t.closest('.ui-select').data('input-target'),
        input_value = t.data('input-value');

    t.closest('.ui-select').find('.selected').removeClass('selected');
    t.addClass('selected');

    $(".input-target[data-input-name='" + input_target + "']").val(input_value);
});

/* UI Checkbox Field */

$('.ui-check a').on('click', function() {
    var input_target = $(this).closest('.ui-check').data('input-target');
    $(this).toggleClass('selected');
    var checkBoxes = $(".input-target[data-input-name='" + input_target + "']");
    checkBoxes.prop('checked', !checkBoxes.prop('checked'));
});

/* Radio UI  */

$('.ui-radio a').on('click', function() {
    var radio_target = $(this).closest('.ui-radio').data('radio-target');
    $(this).closest('.ui-radio').find('.selected').removeClass('selected');
    $(this).addClass('selected');
    var radio_value = $(this).data('radio-value');
    $('input[name="' + radio_target + '"][value="' + radio_value + '"]').prop('checked', true);
});

/* UI Triple Select Field */

$('.ui-selectx3 a').on('click', function() {
    var input_targetx1 = $(this).closest('.ui-selectx3').data('input-targetx1');
    var input_targetx2 = $(this).closest('.ui-selectx3').data('input-targetx2');
    var input_targetx3 = $(this).closest('.ui-selectx3').data('input-targetx3');
    $(this).closest('.ui-selectx3').find('.selected').removeClass('selected');
    $(this).addClass('selected');
    var input_valuex1 = $(this).data('input-valuex1');
    var input_valuex2 = $(this).data('input-valuex2');
    var input_valuex3 = $(this).data('input-valuex3');
    $(".input-target[data-input-name='" + input_targetx1 + "']").val(input_valuex1);
    $(".input-target[data-input-name='" + input_targetx2 + "']").val(input_valuex2);
    $(".input-target[data-input-name='" + input_targetx3 + "']").val(input_valuex3);
});

$("select[data-select='primary']").on('change', function() {
    var selector = $(this);
    if ($(selector).val() !== '') {
        $(selector).closest('.row,.container').find("[data-select='secondary']").fadeIn(300);
    } else {
        $(selector).closest('.row,.container').find("[data-select='secondary']").hide();
    }
});

function chosen_target_url(items, url) {
    var item_amount = $(items).length,
        $url_write = url,
        $counter = 0;

    $.each(items, function(index, value) {

        var item_replace = index + 1;
        var item_value;

        if ($('[name="' + value + '"]').is(':radio')) {
            item_value = $('input[name="' + value + '"]:checked').val();
        } else {
            item_value = $('[name="' + value + '"]').val();
        }

        if (item_value) {
            $counter = $counter + 1;
            $url_write = $url_write.replace('[' + item_replace + ']', item_value);
        } else {
            return false;
        }
    });

    if ($counter == item_amount) {
        $(submit).attr('href', $url_write);
        $(submit).removeAttr('disabled');
    } else {
        $(submit).attr('disabled', 'disabled');
        $(submit).attr('href', '#');
    }

    $counter = 0;
}

/* HANDSET SELECTOR CMS
 ================================================== */

if ($("[data-init='handset-selector']").length) {

    var selector = $("[data-init='handset-selector']"),
        items = $('[data-hs-items]').data('hs-items'),
        url = $('[data-hs-url]').data('hs-url'),
        submit = $('[data-hs-submit]').data('hs-submit');

    $.each(items, function(index, value) {
        var onMethod;

        if (($('[data-hs-option="' + value + '"]').prop('tagName')) == 'SELECT') {
            onMethod = 'change';
        } else {
            onMethod = 'click';
        }

        $('[data-hs-option="' + value + '"]').on(onMethod, function() {
            chosen_target_url(items, url);
        });
    });

}

/* DEAL FINDER - index
 ================================================== */

function go_to_step(fadeout, fadein) {
    $(fadeout).fadeOut('fast', function() {
        $(fadein).show();
    });
}

$('#deal-finder').on('click', '.step-one a', function() {
    $('.deal-breadcrumb li').hide();
    if ($(this).text() == 'Surprise Me') {
        $('.step-one .deal-finder-confirm p').html('<i class="fa fa-check-circle"></i> ' + 'Great, you\'re in for a treat');
        $('li.breadcrumb-step-one span.step-answer').html($(this).text());
    } else {
        $('.step-one .deal-finder-confirm p').html('<i class="fa fa-check-circle"></i> ' + 'You\'re after an <span></span>');
        $('li.breadcrumb-step-one span.step-answer, .step-one .deal-finder-confirm span').html($(this).text());
    }
    $('#phone-selection').hide();
    $('.step-one .deal-finder-confirm').fadeIn(1000, function() {
        setTimeout(function() {
            $('.step-one .deal-finder-confirm').fadeOut(800);
            go_to_step('.step-one', '.step-two');
            $('li.breadcrumb-step-one').show();
        }, 600);
    });
});

$('.step-two a').on('click', function() {
    $('li.breadcrumb-step-two span.step-answer, .step-two .deal-finder-confirm span').html($(this).text());
    $('.step-two .deal-finder-confirm').fadeIn(1000, function() {
        setTimeout(function() {
            $('.step-two .deal-finder-confirm').fadeOut(800);
            go_to_step('.step-two', '.step-three');
            $('.breadcrumb-step-two').show();
        }, 600);
    });
});

$('.step-three a').on('click', function() {
    $('.step-three a').removeClass('selected');
    $(this).addClass('selected');
    $('.step-three .deal-finder-confirm').fadeIn();
    $('.deal-finder-button').hide().fadeIn(800);
});

$('#back-to-one').on('click', function() {
    go_to_step('.step-two', '.step-one');
    $('.deal-breadcrumb li').hide();
    $('.step-one select').val('');
});

$('#back-to-two').on('click', function() {
    $('.deal-finder-button').hide();
    go_to_step('.step-three', '.step-two');
    $('.breadcrumb-step-two').hide();
    $('.step-two select').val('');
});

/* END DEAL FINDER  */

/* ACCORDIANS
 ================================================== */

$('section.accordian .accordian-head').on('click', function() {
    $('.accordian-body').slideUp().parent().removeClass('active');
    $(this).parent().find('.accordian-body').slideDown().parent().addClass('active');
});

/* NAVIGATION START */

jQuery(document).ready(function($) {
    // if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
    var MqL = 992;

    // move nav element position according to window width

    function load_desktop_menu() {
        $('ul#cd-primary-nav').hover(function() {
            $(this).parent().addClass('active');
        }, function() {
            $(this).parent().removeClass('active');
        });

        $('li.nav-menu-item').mouseenter(function() {
            $('.sub-menu-expand').stop(true);
            $(this).addClass('active');
            $(this).find('.sub-menu-expand').stop(true).delay(300).fadeIn(100);
        }).mouseleave(function() {
            $(this).find('.sub-menu-expand').stop(true).hide();
            $(this).removeClass('active');
        });
        $('li.single-link-nav-menu-item a').hover(function() {
            $('.sub-menu-expand').stop(true);
            $('ul#cd-primary-nav').parent().addClass('single-link');
        }, function() {
            $('ul#cd-primary-nav').parent().removeClass('single-link');
        });
        $current_menu = 'desktop';
    }

    function load_mobile_menu() {

        var MqL = 992;

        function closeNav() {
            $('.cd-nav-trigger').removeClass('nav-is-visible');
            $('.cd-main-header').removeClass('nav-is-visible');
            $('.cd-primary-nav').removeClass('nav-is-visible');
            $('.has-children ul').addClass('is-hidden');
            $('.has-children a').removeClass('selected');
            $('.moves-out').removeClass('moves-out');
            $('.cd-main-content').removeClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                $('body').removeClass('overflow-hidden');
            });
        }

        // mobile - open lateral menu clicking on the menu icon
        $('.cd-nav-trigger').on('click', function(event) {
            event.preventDefault();
            if ($('.cd-main-content').hasClass('nav-is-visible')) {
                closeNav();
                $('.cd-overlay').removeClass('is-visible');
            } else {
                $(this).addClass('nav-is-visible');
                $('.cd-primary-nav').addClass('nav-is-visible');
                $('.cd-main-header').addClass('nav-is-visible');
                $('.cd-main-content').addClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                    $('body').addClass('overflow-hidden');
                });
                toggleSearch('close');
                $('.cd-overlay').addClass('is-visible');
            }
        });

        // open search form
        $('.cd-search-trigger').on('click', function(event) {
            event.preventDefault();
            toggleSearch();
            closeNav();
        });

        // close lateral menu on mobile
        $('.cd-overlay').on('swiperight', function() {
            if ($('.cd-primary-nav').hasClass('nav-is-visible')) {
                closeNav();
                $('.cd-overlay').removeClass('is-visible');
            }
        });
        $('.nav-on-left .cd-overlay').on('swipeleft', function() {
            if ($('.cd-primary-nav').hasClass('nav-is-visible')) {
                closeNav();
                $('.cd-overlay').removeClass('is-visible');
            }
        });
        $('.cd-overlay').on('click', function() {
            closeNav();
            toggleSearch('close');
            $('.cd-overlay').removeClass('is-visible');
        });

        // prevent default clicking on direct children of .cd-primary-nav
        $('.cd-primary-nav').children('.has-children').children('a').on('click', function(event) {
            event.preventDefault();
        });
        // open submenu
        $('.has-children').children('a').on('click', function(event) {
            if (!checkWindowWidth()) {
                event.preventDefault();
            }
            var selected = $(this);
            if (selected.next('ul').hasClass('is-hidden')) {
                // desktop version only
                selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
                selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
                $('.cd-overlay').addClass('is-visible');
            } else {
                selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
                $('.cd-overlay').removeClass('is-visible');
            }
            toggleSearch('close');
        });

        // submenu items - go back link
        $('.go-back').on('click', function() {
            $(this).parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('moves-out');
        });
        $current_menu = 'mobile';
    }

    function toggleSearch(type) {
        if (type == 'close') {
            // close serach
            $('.cd-search').removeClass('is-visible');
            $('.cd-search-trigger').removeClass('search-is-visible');
            $('.cd-overlay').removeClass('search-is-visible');
        } else {
            // toggle search visibility
            $('.cd-search').toggleClass('is-visible');
            $('.cd-search-trigger').toggleClass('search-is-visible');
            $('.cd-overlay').toggleClass('search-is-visible');
            if ($(window).width() > MqL && $('.cd-search').hasClass('is-visible')) {
                $('.cd-search').find('input[type="search"]').focus();
            }
            ($('.cd-search').hasClass('is-visible')) ? $('.cd-overlay').addClass('is-visible') : $('.cd-overlay').removeClass('is-visible');
        }
    }

    function checkWindowWidth() {
        // check window width (scrollbar included)
        var e = window,
            a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        if (e[a + 'Width'] >= MqL) {
            return true;
        }
        return false;

    }

    // Load initial menus
    if (checkWindowWidth()) {
        $('body').addClass('desktop-menu');
        load_desktop_menu();
    } else {
        $('body').addClass('device-menu');
        load_mobile_menu();
    }

    function windowWidthMenu() {
        if (checkWindowWidth() && $current_menu !== 'desktop') {
            $('body').removeClass('device-menu');
            $('body').addClass('desktop-menu');
            load_desktop_menu();
        } else if (!checkWindowWidth() && $current_menu !== 'mobile') {
            $('body').removeClass('desktop-menu');
            $('body').addClass('device-menu');
            load_mobile_menu();
        }
    }

    $(window).on('resize', function() {
        windowWidthMenu();
    });

    $('.modal-tariff-info').appendTo('body');
});

/* NAVIGATION END */

jQuery(document).ready(function($) {

    // stop youtube video playing when closing modal
    $('#video-window').on('hidden.bs.modal', function() {
        var video_iframe = $('iframe[src*="youtube"]');
        var video = $(video_iframe).attr('src');
        $(video_iframe).attr('src', '');
        $(video_iframe).attr('src', video);

    });

});

// stock messaging alerts

jQuery(document).ready(function($) {
    if ($('#product-stock-message').text()) {
        $.growl({
            title: $('#product-stock-message').text(),
            message: '',
            size: 'large',
            style: 'stock-message',
            duration: 10000
        });
    }
});

// Starting a templates module for E2SaveApp for the generate template cache
angular.module('templates', []);

var E2SaveApp = angular.module('E2SaveApp', [
    'ngMaterial',
    'ngMessages',
    'ProductFinder.components',
    'Search.components',
    'templates'
]).config(['$mdThemingProvider', function($mdThemingProvider) {
    $mdThemingProvider.disableTheming();
}]);

E2SaveApp.$inject = ['ngMaterial', 'ngMessages', 'ProductFinder.components', 'Search.components', '$mdThemingProvider', 'templates'];

function search() {
    $('.search-box .input').off('keypress.resultshow');
    $('#search-panel').toggle();
}

$('.search-box .input').on('keypress', function(event) {
    return event.keyCode != 13;
});

$('.search-box .input').on('keypress.resultshow', function() {
    search();
});

$('.clear-search').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    $('#search-panel').hide();
    $('.search-box .input').val('');
    $('.search-box .input').on('keypress.resultshow', function() {
        search();
    });
});

$(document).ready(function() {
    basketCounter.init();
});

function setUpCoverageCheckerModal(event) {
    var $buyButton = $(event.currentTarget);
    var $modal = $($buyButton.attr('data-coverage-checker'));
    $modal.find('[data-continue-to-basket]').attr('href', $buyButton.attr('href'));
    $modal.modal();
}

$('[data-coverage-checker]').on('click', function(event) {
    event.preventDefault();
    setUpCoverageCheckerModal(event);
});

$(document).ready(function() {
    var isPLP = $('.listing-asa-message').length > 0;
    var filter = $('.filter-button');
    var targetElement = null;
    var filterOffset = null;

    if (isPLP) {
        targetElement = $('#tile-layout');
        filterOffset = targetElement.offset().top;

        $(window).scroll(function() {
            var scrollPosition = $(window).scrollTop();
            var targetElementOffset = targetElement.offset().top + targetElement.height();

            var isBellowFilter = scrollPosition >= filterOffset;
            var isAboveTargetElement = scrollPosition < targetElementOffset;

            filter.toggleClass('sticky-filter-button', isBellowFilter && isAboveTargetElement);
        });
    } else {
        targetElement = $('.deal-contracts-table').parent();
        filterOffset = targetElement.offset().top;
        var mobileAsaMessage = $('.listing-asa-message-filter-traffic-table');
        var filterBtn = $('.filter-open');

        $(window).scroll(function() {
            var scrollPosition = $(window).scrollTop();
            var targetElementOffset = targetElement.offset().top + targetElement.height();

            var isBellowFilter = scrollPosition >= filterOffset;
            var isAboveTargetElement = scrollPosition < targetElementOffset;

            var isSmallScreen = window.innerWidth < 992;

            if (isBellowFilter && isAboveTargetElement && isSmallScreen) {
                mobileAsaMessage.removeClass('hidden');
                filterBtn.addClass('btn-primary');
                filterBtn.removeClass('btn-alt');
                filterBtn.parent().removeClass('pull-right');
                filterBtn.parent().addClass('sticky-filter-open');
            } else {
                filterBtn.removeClass('btn-primary');
                filterBtn.addClass('btn-alt');
                filterBtn.parent().addClass('pull-right');
                filterBtn.parent().remove('sticky-filter-open');
                mobileAsaMessage.addClass('hidden');
            }

            filter.toggleClass('sticky-filter-button', isBellowFilter && isAboveTargetElement && isSmallScreen);
        });
    }
});

$(document).ready(function() {
    var filter = $('.listing-asa-message');
    var targetElement = null;
    var filterOffset = null;

    if (filter.length > 0) {
        targetElement = $('#tile-layout');
        filterOffset = targetElement.offset().top;

        $(window).scroll(function() {
            var scrollPosition = $(window).scrollTop();
            var targetElementOffset = targetElement.offset().top + targetElement.height();

            var isBellowFilter = scrollPosition >= filterOffset;
            var isAboveTargetElement = scrollPosition < targetElementOffset;
            var isMediumScreen = window.innerWidth > 991;

            filter.toggleClass('sticky-listing-asa-message', isBellowFilter && isAboveTargetElement && isMediumScreen);
        });
    } else {
        filter = $('.product-tariff-listing-asa-message');
        targetElement = $('.deal-contracts-table').parent();
        filterOffset = targetElement.offset().top;

        $(window).scroll(function() {
            var scrollPosition = $(window).scrollTop();
            var targetElementOffset = targetElement.offset().top + targetElement.height();

            var isBellowFilter = scrollPosition >= filterOffset;
            var isAboveTargetElement = scrollPosition < targetElementOffset;
            var isMediumScreen = window.innerWidth > 991;

            filter.toggleClass('sticky-product-tariff-listing-asa-message', isBellowFilter && isAboveTargetElement && isMediumScreen);
        });
    }
});

$(document).ready(function() {
    $('.visible-xs-block.product-details-esim-info-box').on('click', function(event) {
        event.preventDefault();
        $('#main').addClass('esim-popup-open-modal');
    });
});
